import React from 'react';

import { CheckCircleFillIcon, Text } from '@thefarmersfront/kitchen';

import styles from './SuccessInfoMessage.module.scss';

type TypeSuccessInfoMessageProps = {
  message?: string;
};

/**
 * Input 등의 컴포넌트와 조합해 사용하는 success 메시지 컴포넌트
 */
const SuccessInfoMessage = ({ message = '' }: TypeSuccessInfoMessageProps) => {
  return (
    <div className={styles['validation-message']}>
      <CheckCircleFillIcon size={16} color="#029568" />
      <Text size="small" color="success">
        {message}
      </Text>
    </div>
  );
};

export default SuccessInfoMessage;
